import java from '../images/java.png'
import csharp from '../images/csharp.png'
import py from '../images/python.png'
import django from '../images/django.svg'
import dotnet from '../images/dotnet.png';
import rest from '../images/rest.png'
import html from '../images/html.png'
import css from '../images/css.png'
import javascript  from '../images/javascript.png'
import react from '../images/react.png'
import vscode from '../images/vscode.png'
import visual_studio from '../images/visual-studio.png';
import git from '../images/git.png'
import figma from '../images/figma.png'
import tailwind from '../images/tailwind.png'
import mysql from '../images/mysql.png'
import postman from '../images/postman.png'
import vue from '../images/vue.png'
import mssql from '../images/mssql.png';


const SkillData ={
    "Programming":[
        {
            name : 'C#',
            image : csharp
        },
        {
            name:'Javascript',
            image:javascript
        },
        {
            name:'Python',
            image:py
        },
        {
            name:'Java',
            image:java
        },
        
    ],
    "Frontend":[
        {
            name:'Hyper Text Markup Language',
            image:html
        },
        {
            name:'Cascading Style Sheets',
            image:css
        },
        {
        name:'React Js / React Native',
        image:react
        },
        {
            name: 'Vue Js',
            image : vue
        },
        {
            name:'Tailwind CSS',
            image:tailwind
        }
        
    ],

    "Backend":[
        {
            name:'Django',
            image:django
        },
        {
            name:'Djangorest framework',
            image:rest
        },
        {
            name : 'DotNet',
            image : dotnet
        }
    ],
    // "Problem Solving":[
    //     {
    //         name:'Code Chef',
    //         image:codechef
    //     }
    // ],
    "Tools":[
        {
            name:'VS Code',
            image: vscode
        },
        {
            name : 'Visual Studio IDE',
            image:visual_studio
        },
        {
            name : 'Git',
            image : git
        },
        {
            name : 'Postman',
            image : postman
        },
        {
            name : 'Figma',
            image : figma
        }
    ],
    "Databases":[
        {
            name:'MySql',
            image : mysql
        },
        {
            name  :  'Microsoft Sql Server',
            image:mssql
        }
    ]
}

export default SkillData;

